import React from 'react';
import { StatusBadgeProps, SIZE_STYLES } from './types';

/**
 * Generic status badge component.
 * Displays a colored pill badge for entity status.
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  statusConfig,
  defaultStatus,
  size = 'small',
  onClick,
  clickable = false
}) => {
  const config = statusConfig[status] || statusConfig[defaultStatus];

  const badgeStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    borderRadius: '9999px',
    fontWeight: '500',
    backgroundColor: config.bgColor,
    color: config.color,
    border: `1px solid ${config.color}`,
    cursor: clickable ? 'pointer' : 'default',
    transition: 'all 0.15s ease',
    ...SIZE_STYLES[size]
  };

  return (
    <span onClick={onClick} style={badgeStyle}>
      {config.label}
      {clickable && (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" style={{ marginLeft: '2px' }}>
          <path d="M7 10l5 5 5-5z" />
        </svg>
      )}
    </span>
  );
};

export default StatusBadge;
